import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { bancosAPI } from '../services/api';
import { toast } from 'react-toastify';
import '../Clientes.css';

const BancoForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    nombre: '',
    codigo: '',
    activo: true
  });

  const loadBanco = useCallback(async () => {
    try {
      const response = await bancosAPI.getById(id);
      if (response.success) {
        setFormData(response.data);
      }
    } catch (error) {
      toast.error('Error al cargar banco');
      navigate('/bancos');
    }
  }, [id, navigate]);

  useEffect(() => {
    if (id) {
      loadBanco();
    }
  }, [id, loadBanco]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      let response;
      if (id) {
        response = await bancosAPI.update(id, formData);
      } else {
        response = await bancosAPI.create(formData);
      }

      if (response.success) {
        toast.success(id ? 'Banco actualizado exitosamente' : 'Banco creado exitosamente');
        navigate('/bancos');
      }
    } catch (error) {
      toast.error(error.message || 'Error al guardar banco');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cliente-form">
      <h1>{id ? 'Editar Banco' : 'Nuevo Banco'}</h1>
      <div className="form-container">
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Nombre *</label>
            <input
              type="text"
              name="nombre"
              value={formData.nombre}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Código</label>
            <input
              type="text"
              name="codigo"
              value={formData.codigo}
              onChange={handleChange}
              placeholder="Código del banco (opcional)"
            />
          </div>

<div className="form-group">
          <label className="form-toggle-wrap">
            <span className="toggle-switch-box">
              <input
                type="checkbox"
                name="activo"
                checked={formData.activo}
                onChange={handleChange}
              />
              <span className="form-toggle-switch" />
            </span>
            <span className="form-toggle-label">{formData.activo ? 'Desactivar' : 'Activar'}</span>
          </label>
        </div>

          <div className="form-actions">
            <button type="button" onClick={() => navigate('/bancos')} className="btn-secondary">
              Cancelar
            </button>
            <button type="submit" disabled={loading} className="btn-primary">
              {loading ? 'Guardando...' : 'Guardar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BancoForm;

